import React, { useState } from "react";
import "./style.scss";
import ChatList from "./components/ChatList";
import Search from "components/BaseWidgets/search";
import { useChatDetail } from "hooks/api/useChatDetail";
import { useQueryClient } from "@tanstack/react-query";
import EmptyState from "components/BaseWidgets/emptyState";

function LeftPanel({
  userChats = [],
  currentUserId,
  setSelectedChatId,
  selectedChatId,
  setSelectedThread,
  selectedThread,
  listType,
  setSearchTerm,
  searchTerm,
  segment,
  isLoading,
}) {
  // console.log(userChats, "userChats");

  const queryClient = useQueryClient();

  // console.log(selectedThread, "selectedThread");

  const id = selectedThread?.aec_id;
  const { data: chatDetail } = useChatDetail({
    id: id,
  });

  // console.log(chatDetail, "chatDetail");

  // const searchedChats = userChats.filter((chat) => {
  //   const otherUserId = chat?.users?.find((id) => id !== currentUserId);
  //   const otherUser = chat?.participants?.[otherUserId];
  //   return otherUser?.name?.toLowerCase()?.includes(searchTerm.toLowerCase());
  // });

  const list = userChats.chat_data || [];

  const filteredChats = list.filter((chat) => {
    const unread = chat.unread_count > 0;
    // console.log(chat, "jh");

    const favorite = chat.favorite === 1 || chat.favorite === true;

    if (segment === "unread") return unread;
    if (segment === "favourite") return favorite;

    return true; // all
  });

  return (
    <div className="chat-wrapper">
      <Search
        className="search-field"
        onSearch={(value) => setSearchTerm(value)}
      />
      <div className="flex flex-col gap-3 chat-list-container">
        {/* 🟡 EMPTY BEFORE SEARCH */}
        {userChats.length === 0 && searchTerm === "" && (
          <div className="no-results">
            {listType === "unread" ? "No unread chats" : "No chats available"}
          </div>
        )}

        {/* 🟡 EMPTY AFTER SEARCH */}
        {userChats?.length > 0 && filteredChats?.length === 0 && (
          <div className="no-results">
            {listType === "unread" ? (
              "No unread chats found"
            ) : (
              <>
                No results found for "<span>{searchTerm}</span>"
              </>
            )}
          </div>
        )}

        {/* 🟢 SHOW CHAT LIST */}
        {isLoading ? (
          <div className="no-results">Chat loading...</div>
        ) : filteredChats.length === 0 ? (
          <EmptyState />
        ) : (
          filteredChats.map((chat) => (
            <ChatList
              key={chat.chatId}
              data={chat}
              selectedThread={selectedThread}
              isActive={chat?.thread_id === selectedThread?.thread_id}
              currentUserId={currentUserId}
              onSelectChat={(chatId, data) => {
                setSelectedThread(data);

                setSelectedChatId(chatId);
                queryClient.invalidateQueries(["chat-threads"]);
              }}
            />
          ))
        )}
      </div>
    </div>
  );
}

export default LeftPanel;
